import React from "react"
import {connect} from "react-redux"
import * as at from "../actionTypes";
import Select from "react-select";
import * as jl from "../JobLevels"

const jobLevels = [jl.LocationProviderKey, jl.LocationKey, jl.UserKey, jl.AccountKey, jl.BillingAccountKey, jl.CredentialKey, jl.RemotePageKey, jl.GlobalKey];

const UnconnectedJobTypeSelector = ({
                                      dispatch,
                                      jobTypesByJobLevel,
                                      jobTypesLoading,
                                      selectedJobType
                                    }) => {
  const options =
    jobLevels.reduce((sum, level) => {
      const title = {
        display: <span className="text-muted">{jl.info[level].label}</span>,
      };
      let jobTypes = (jobTypesByJobLevel[level] || []);
      return sum.concat([title]).concat(jobTypes.map(jobType => {
        return {
          value: jobType.id,
          display: <span style={{paddingLeft: '10px'}}>{jobType.id}</span>,
          onSelected: () => dispatch({ type: at.SET_JOB_TYPE, jobType: jobType.id, jobLevel: level })
        }
      }))
    }, []);

  return <Select
    isLoading={jobTypesLoading}
    clearable={false}
    options={options}
    value={options.find(id => selectedJobType && selectedJobType.id)}
    onChange={(opt) => opt && opt.onSelected && opt.onSelected()}
    formatOptionLabel={(x) => x.display}
    formatValueLabel={(x) => x.display}
    placeholder={`Select a job type...`}
  />
}

export const JobTypeSelector = connect(function mapStateToProps(state, ownProps) {
  const {
    jobTypesByJobLevel, jobTypesLoading, selectedJobType
  } = state.manageTool;
  return {
    jobTypesByJobLevel, jobTypesLoading, selectedJobType,
    ...ownProps
  }
})(UnconnectedJobTypeSelector);
